module.exports = __webpack_public_path__ + "static/mk11_1920x900.08748210.png";